<template>
	<div class="container">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
					<a href="#">首頁</a>
				</router-link>
				<router-link :to="{ name: 'Compensate'}" tag="li" class="breadcrumb-item">
					<a href="#">補償刀</a>
				</router-link>
			</ol>
		</nav>
		<div class="item-box">
			<h3 class="item-title">補償刀秒數試算</h3>
			<div class="row mb-3">
				<div class="col-12 mb-3">
					<div class="pcbtn mr-3" @click="SwitchUnit()" :class="isAbbreviation ? 'active': ''">單位: 萬</div>
				</div>
				<div class="col-12 my-1">
					<label for="">當前血量 <span class="lead"><span class="badge badge-success">{{CurrentHp}}</span></span> <span v-if="isAbbreviation">萬</span></label>
					<input type="number" class="form-control" v-model="currentHp" placeholder="請輸入血量">
				</div>
				<div class="col-md-6 col-12 my-1">
					<label for="">第一刀傷害 <span class="lead"><span class="badge badge-danger">{{FristDmg}}</span></span> <span v-if="isAbbreviation">萬</span></label>
					<input type="number" class="form-control" v-model="firstDmg" placeholder="請輸入第一刀傷害">
				</div>
				<div class="col-md-6 col-12 my-1">
					<label for="">第二刀傷害 <span class="lead"><span class="badge badge-danger">{{SecondDmg}}</span></span> <span v-if="isAbbreviation">萬</span></label>
					<input type="number" class="form-control" v-model="secondDmg" placeholder="請輸入第二刀傷害">
				</div>
			</div>
			<div class="row">
				<div class="col-12 mb-3">
					<h3 class="item-sub-title d-inline-block" data-toggle="popover" data-placement="bottom" title="遺留時間" data-html="true" data-content="在正式戰的戰鬥中，若在時間結束前擊倒怪物的話，則會發生「遺留時間」。<br />
						在次回於正式戰的挑戰中，並不會消耗新的挑戰次數，而是使用遺留下的時間進行戰鬥。<br />
						而遺留時間將會根據擊倒怪物時所剩餘的時間來進行計算並得出。<br />
						此外，若有複數成員同時擊倒怪物時，將會包含擊倒時所造成的傷害一併計算出遺留時間。<br />
						使用遺留時間所開始的戰鬥若結束了，則遺留時間將會消失。<br />
						在使用遺留時間所開始的戰鬥中，即使擊倒怪物，也不會再發生新的遺留時間。	<br />">遺留時間</h3>
					<br>
					<div class="pcbtn mr-3" @click="isOld = !isOld" :class="isOld ? 'active': ''">+10秒</div>
					<div class="pcbtn mr-3" @click="isOld = !isOld" :class="!isOld ? 'active': ''">+20秒</div>
				</div>
				<div class="col-12">
					補償刀 <h3 class="d-inline-block"><span class="badge badge-primary">{{last}}</span></h3>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Compensate',
	data() {
		return {
			currentHp: "9000000",
			firstDmg: "6600000",
			secondDmg: "8300000",
			isAbbreviation: false,
			isOld: false,
			countTable: [{
				"bonus": 1.1,
				"give": 29
			}, {
				"bonus": 1.2,
				"give": 35
			}, {
				"bonus": 1.3,
				"give": 41
			}, {
				"bonus": 1.4,
				"give": 46
			}, {
				"bonus": 1.5,
				"give": 50
			}, {
				"bonus": 1.6,
				"give": 54
			}, {
				"bonus": 1.7,
				"give": 58
			}, {
				"bonus": 1.8,
				"give": 60
			}, {
				"bonus": 1.9,
				"give": 63
			}, {
				"bonus": 2,
				"give": 65
			}, {
				"bonus": 3,
				"give": 80
			}, {
				"bonus": 4,
				"give": 88
			}, {
				"bonus": 4.3,
				"give": 90
			}]
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '補償刀',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki'
	},
	methods: {
		beCommas: function(item) {
			item = item.toString();
			return item.replace(/\D/g, "")
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		SwitchUnit: function() {
			this.isAbbreviation = !this.isAbbreviation;
			if (this.currentHp / 10000 > 1) {
				this.currentHp = this.currentHp / 10000
			} else {
				this.currentHp = this.currentHp * 10000
			}

			if (this.firstDmg / 10000 > 1) {
				this.firstDmg = this.firstDmg / 10000
			} else {
				this.firstDmg = this.firstDmg * 10000
			}

			if (this.secondDmg / 10000 > 1) {
				this.secondDmg = this.secondDmg / 10000
			} else {
				this.secondDmg = this.secondDmg * 10000
			}
		}
	},
	created: function() {
		var self = this;
	},
	computed: {
		last: function() {
			var first = Number(this.firstDmg);
			var secondDmg = Number(this.secondDmg);
			var current = Number(this.currentHp);
			if (first + secondDmg < current) {
				var needDmg = (current - (first + secondDmg));
				var result = this.beCommas(needDmg);
				return "傷害不足 還少 " + result;
			}
			var makeUp = 20;
			if (this.isOld) {
				makeUp = 10
			}
			var returnSec = (90 - (90 * (current - first) / secondDmg) + makeUp).toFixed(2);
			if (returnSec > 90) {
				return returnSec + " 補償完整刀";
			} else {
				return Math.ceil(returnSec) + "秒"
			}
		},
		CurrentHp: function() {
			return this.beCommas(Math.floor((Number(this.currentHp))))
		},
		FristDmg: function() {
			return this.beCommas(Math.floor((Number(this.firstDmg))))
		},
		SecondDmg: function() {
			return this.beCommas(Math.floor((Number(this.secondDmg))))
		},
	},
	mounted: function() {
		var self = this;
		$('[data-toggle="popover"').popover({html : true});
	}
}
</script>

